<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.teacher_fouls', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <div class="md:grid md:grid-cols-3 md:gap-6">
                <div class="mt-5 md:mt-0 md:col-span-2">
                    <div class="md:grid md:grid-cols-6 md:gap-6">
                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.date')" for="date" />
                                <FormInput
                                    required
                                    id="date"
                                    v-model="form.date"
                                    name="date"
                                    type="date"
                                    class="w-full mt-1"
                                />
                                <FormError :value="form.errors.date" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.time')" for="time" />
                                <FormInput
                                    required
                                    id="time"
                                    v-model="form.time"
                                    name="time"
                                    type="time"
                                    class="w-full mt-1"
                                />
                                <FormError :value="form.errors.time" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                {{ teacher.full_name }}
                            </div>
                        </div>

                        <div class="sm:col-span-6">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.comment')" for="comment" />
                                <FormTextarea
                                    rows="3"
                                    id="comment"
                                    v-model="form.comment"
                                    name="comment"
                                    type="text"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.comment" class="mt-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        FormInput,
        FormLabel,
        FormError,
        FormTextarea,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'teacher_foul'],
    data() {
        return {
            form: this.$inertia.form({
                date: this.teacher_foul.date,
                time: this.teacher_foul.time,
                comment: this.teacher_foul.comment,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
